import React, { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { Form, FormGroup, Label, Input, Col } from 'reactstrap';
// ========= action import section ========= //
import continueIcon from '../../../images/continue.png';
import noUserPreferenceImg from '../../../images/no-user-preference.png';
import { getUserPreference } from '../../../actions/surveyAction';
import SurveyModal from '../../Modals/SurveyModal';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import DataSurveyInterface, {
  PreferenceStateInterface,
} from '../../../interface/reducers/survey';
// ====== end of interface import section ====== //

type stateToProps = {
  dataSurvey: DataSurveyInterface;
};
interface UserPreferencesInterface extends stateToProps {
  doFetchUserPreference: () => Promise<any>;
  preferences: PreferenceStateInterface;
}

/**
 * User Preferences Tab on Setting User Dashboard section for Kick Avenue 3.0 Website.
 * ===============================================
 * @param {UserPreferencesInterface} props for this component.
 * @return {JSX.Element}
 */
function UserPreferencesTab({
  doFetchUserPreference,
  preferences,
}: UserPreferencesInterface): JSX.Element {
  const [showSurveyModal, setShowSurveyModal] = useState(false);

  useEffect(() => {
    doFetchUserPreference();
  }, []);

  const setValue = (val: string, type: string) => {
    let newVal = val;
    if (type === 'gender') {
      if (val === 'M') {
        newVal = 'Men';
      } else if (val === 'F') {
        newVal = 'Women';
      }
    }

    return newVal;
  };

  const noPreferenceFound = () => (
    <Col sm={{ size: 6, offset: 3 }}>
      <div className="text-center">
        <KickImage
          style={{ width: '80%' }}
          src={noUserPreferenceImg}
          alt="noUserPreference"
          className="my-4"
        />
        <p className="no-user-preference-title">
          Tell us what your preferences are!
        </p>
        <p className="no-user-preference-text mb-1">
          Set your preferences, so we can give you better experience.
        </p>
        <div
          className="user-preference-set-button my-4"
          style={{ width: '50%' }}
        >
          <div onClick={() => setShowSurveyModal(!showSurveyModal)}>
            Set preferences
          </div>
        </div>
      </div>
    </Col>
  );

  return (
    <div id="user-preference">
      {preferences.isFetch ? 
      <div className="text-center">
        <div className="spinner-border text-success" />
      </div>
      : 
      <Form>
        {preferences && preferences.data.length > 0 ? (
          <div>
            {preferences.data.map((item, index) => (
              <div key={index}>
                <FormGroup className="mb-4 user-preference-form">
                  <Label
                    for={'form' + item.label_group}
                    className="user-preference-form-label"
                  >
                    {item.optionable_type === 'size'
                      ? item.optionable_type + ' (US)'
                      : item.optionable_type}
                  </Label>
                  <Input
                    disabled
                    className="user-preference-form-input"
                    type="text"
                    id={'form' + item.label_group}
                    name={item.label_group}
                    value={setValue(item.value, item.optionable_type)}
                  />
                </FormGroup>
              </div>
            ))}
            <FormGroup className="mb-0">
              <div onClick={() => setShowSurveyModal(!showSurveyModal)}>
                <div className="user-preference-change-button">
                  <p className="float-left text-white mb-0">
                    Change preferences
                  </p>
                  <p className="float-right text-white mb-0">
                    <KickImage src={continueIcon} alt="Continue" />
                  </p>
                  <div style={{ clear: 'both' }}></div>
                </div>
              </div>
            </FormGroup>
          </div>
        ) : (
          noPreferenceFound()
        )}
        <SurveyModal
        show={showSurveyModal}
        welcomePage={false}
        handleShowSurvey={() => {
          setShowSurveyModal(!showSurveyModal);
          doFetchUserPreference()
        }}
      />
      </Form>}
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    preferences: state.dataSurvey.preferences,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doFetchUserPreference: () => dispatch(getUserPreference()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPreferencesTab);
